// extracted by mini-css-extract-plugin
module.exports = {"tab-bar":"tab-bar-a00186328898c1b593159fdc8d19654e"};